export const firebaseConfig = {
  apiKey: 'AIzaSyBKqhc8E3J4SdR2VOJ7DnscC5K0DKvIbM4',
  authDomain: 'pokado-7d815.firebaseapp.com',
  projectId: 'pokado-7d815',
  storageBucket: 'pokado-7d815.appspot.com',
  messagingSenderId: '323345176847',
  appId: '1:323345176847:web:26a5fb6af173ce7abc067a',
  measurementId: 'G-Q0X6LERQH2',
};
